module.exports = __webpack_public_path__ + "img/tjggb.fa93a582.png";